// Mock data for Jupiter Group website

export const companyInfo = {
  name: 'Jupiter Group',
  tagline: 'Workforce | Staffing | Outsourcing',
  managingDirector: 'Aniket Patil',
  phone: '7666713701',
  email: 'jupitergroup0101@gmail.com',
  address: 'Sr. No. 42/A, Near Ratnadip Hotel, Kalepadal, Hadapsar, Pune – 411028',
  gst: '27BPDPP5516H1ZS',
  instagram: '@jupitergroupofficial',
  instagramUrl: 'https://instagram.com/jupitergroupofficial'
};

export const about = {
  description: 'Jupiter Group is a professionally managed manpower supply and staffing company providing skilled, semi-skilled and unskilled workforce across multiple industries. We focus on reliable deployment, compliance-driven operations and long-term client partnerships.',
  vision: 'To become a trusted manpower partner by delivering reliable workforce solutions with integrity, efficiency and professionalism.'
};

export const services = [
  {
    id: 1,
    title: 'Workforce Supply',
    description: 'Comprehensive workforce solutions tailored to your business needs with skilled, semi-skilled and unskilled personnel.'
  },
  {
    id: 2,
    title: 'Contract Staffing',
    description: 'Flexible contract staffing solutions with qualified professionals for short-term and long-term requirements.'
  },
  {
    id: 3,
    title: 'Outsourcing Services',
    description: 'Complete outsourcing services to help you focus on core business while we manage your workforce needs.'
  },
  {
    id: 4,
    title: 'Temporary Staffing',
    description: 'Quick deployment of temporary staff for seasonal demands, projects, or business fluctuations.'
  },
  {
    id: 5,
    title: 'Permanent Staffing',
    description: 'Permanent placement services to build your team with the right talent for long-term success.'
  },
  {
    id: 6,
    title: 'Bulk Manpower Deployment',
    description: 'Large-scale workforce deployment for major projects and operations requiring significant manpower.'
  },
  {
    id: 7,
    title: 'Project-Based Manpower Supply',
    description: 'Dedicated manpower solutions for specific projects with defined timelines and deliverables.'
  }
];

export const industries = [
  {
    id: 1,
    title: 'IT Companies, Corporate & Government Offices',
    description: 'Professional staffing for corporate environments'
  },
  {
    id: 2,
    title: 'Hotels & Resorts',
    description: 'Hospitality workforce for hotels and resorts'
  },
  {
    id: 3,
    title: 'Malls & Commercial Complexes',
    description: 'Retail and facility management staff'
  },
  {
    id: 4,
    title: 'Societies & Residential Complexes',
    description: 'Residential facility management workforce'
  },
  {
    id: 5,
    title: 'Hospitals & Clinics',
    description: 'Healthcare support staff and facility management'
  },
  {
    id: 6,
    title: 'Franchises (Food, Retail & Service)',
    description: 'Franchise operation workforce solutions'
  }
];

export const whyChooseUs = [
  'Trained & Verified Manpower',
  'Quick Deployment & Easy Scalability',
  'Replacement within 24–48 Hours',
  'Affordable & Transparent Pricing',
  'PF, ESI & Minimum Wages Compliance',
  'Professional Management Team',
  'Dedicated Client Support'
];

export const images = {
  hero: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0',
  about: 'https://images.unsplash.com/photo-1606857521015-7f9fcf423740',
  services: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d',
  industries: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72',
  contact: 'https://images.unsplash.com/photo-1686771416282-3888ddaf249b',
  corporate: 'https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg'
};
